<app-page-header avatarHeader="true" [loadingInitialData]="loadingInitialData" [initials]="organization?.initials">
    {{ pageTitle }}
    <a mat-icon-button disableRipple
       [attr.aria-label]="routerBackButton.ariaLabel"
       [routerLink]="routerBackButton.route">
        <mat-icon>arrow_back</mat-icon>
    </a>
</app-page-header>

<app-details-card-container [actionLines]="lines"
                            [showActions]="true"
                            [actions]="actions"
                            [loadingSubject$]="loadingSubject$"
                            (actionClicked)="$event.callback()">
    <mat-card>
        <mat-card-title>{{ 'Details' }}</mat-card-title>

        <mat-progress-bar mode="query" color="primary" [class.active]="!loadingInitialData && refreshingOrganization"></mat-progress-bar>

        <mat-divider></mat-divider>

        <mat-card-content>
            <mat-list [loadingList]="!organization" combineLines>
                <mat-list-item>
                    <span matListItemTitle>{{ 'Units' }}</span>
                    <span matListItemLine>{{ (organization?.unitsCount || 0) | number:'1.0':'en-US' }}</span>
                </mat-list-item>

                <!--mat-list-item>
                    <span matListItemTitle>{{ 'Homeowners' }}</span>
                    <span matListItemLine>{{ (organization?.ownersCount || 0) | number:'1.0':'en-US' }}</span>
                </mat-list-item-->

                <mat-list-item>
                    <span matListItemTitle>{{ 'Managers' }}</span>
                    <ng-container *ngFor="let admin of organization?.admins; let isLast = last">
                        <a [routerLink]="['/pmc', pmcId, 'team', admin.userId, 'details']"
                           [innerHTML]="admin.profile?.givenNames + ' ' + admin.profile?.familyName + (!isLast ? ',' : '')"
                           linkButton
                           matListItemLine>
                        </a>
                    </ng-container>
                </mat-list-item>

                <!--mat-list-item>
                    <span matListItemTitle>{{ 'Vendors' }}</span>
                    <span matListItemLine>{{ (organization?.vendorsCount || 0) | number:'1.0':'en-US' }}</span>
                </mat-list-item-->

                <mat-list-item>
                    <span matListItemTitle>{{ 'Open Submissions' }}</span>
                    <span matListItemLine>{{ (organization?.openSubmissionsCount || 0) | number:'1.0':'en-US' }}</span>
                </mat-list-item>

                <mat-list-item>
                    <span matListItemTitle>{{ 'Open Violations' }}</span>
                    <span matListItemLine>{{ (organization?.openViolationsCount || 0 ) | number:'1.0':'en-US' }}</span>
                </mat-list-item>
            </mat-list>
        </mat-card-content>
    </mat-card>
</app-details-card-container>
